<script lang="ts" module>
  import { uniqueContext } from "#lib/internal/helpers"
  import type { BaseProps } from "#lib/internal/types"

  type Props = BaseProps & {
    children?: any
  }

  export type RootContext = {
    anchor: HTMLElement | null
    arrow: HTMLElement | null
  }

  const { getContext, setContext } = uniqueContext<RootContext>()
  export const getPopperRootContext = getContext
</script>

<script lang="ts">
  import type { Snippet } from "svelte"

  type PopperRootProps = Props & { children?: Snippet }

  let { children }: PopperRootProps = $props()

  let anchor: HTMLElement | null = $state(null)
  let arrow: HTMLElement | null = $state(null)

  setContext({
    get anchor() {
      return anchor
    },
    set anchor(v) {
      anchor = v
    },
    get arrow() {
      return arrow
    },
    set arrow(v) {
      arrow = v
    },
  })
</script>

{@render children?.()}
